import React from "react";
import { Main } from "../HomeComponents";

export const Home = () => {
  return (
    <>
      <Main />
    </>
  );
};
